module.exports = '<svg width="40" height="32" viewBox="0 0 40 32"><path d="M38.536 8H36.19V2c0-1.106-1.642-2-2.708-2H6.45C5.382 0 4.19.894 4.19 2v6H1.396C.326 8-.318 8.8.16 9.79l4.032 8.684V30c0 1.106 1.192 2 2.26 2h27.032c1.066 0 2.708-.894 2.708-2V18.472l3.8-8.684C40.472 8.8 39.602 8 38.536 8zm-6.346 9.528V28h-24V17.528L5.712 12H34.22l-2.03 5.528zm-12.77 8.164c.424.446 1.114.39 1.538-.05l4.986-4.738c.426-.446.286-.904-.316-.904H22.19v-4.938c0-.552-.448-1.062-1-1.062h-2c-.552 0-1 .51-1 1.062V20h-3.438c-.602 0-.744.43-.318.876l4.986 4.816z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/fold-down-1.js
// module id = 1150
// module chunks = 14